<template>
  <section
    id="pengumuman-list"
  >
    <!-- title text and switch button -->
    <div class="text-center">
      <h1 class="mt-2 mb-5">
        Pengumuman Terkini
      </h1>
    </div>
    <!--/ title text and switch button -->
  
    <!-- pricing plan cards -->
    <b-row class="pricing-card mt-5">
      <b-col
        offset-sm-2
        sm="4"
        md="4"
        offset-lg="2"
        lg="4"
        class="mx-auto"
        v-for="item in pengumuman" :key="item.id"
      >
      <b-card
        align="center"
      >
                  <!-- img -->
              <b-img
                v-if="imgDefault"
                :src="imgDefault"
                class="mb-2"
                alt="basic svg img"
              />
              <!--/ img -->
              <b-card-text>
                  {{ item.tanggal }}
                </b-card-text>
               <h3>{{ item.judul }}</h3>
 
              <!-- buttons -->
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                class="mt-2 mb-2"
                variant="warning"
                :href="item.link"
              >
                Selengkapnya
              </b-button>
            </b-card>
          </b-col>
          
    </b-row>
  
    <!--/ pricing plan cards -->
  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Ripple from 'vue-ripple-directive'
/* eslint-disable global-require */
import {
  getPengumuman,
} from '@/connection-api/pengumuman'
export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      status: 'monthly',
      monthlyPlanShow: true,
      pricing: {},
      pengumuman: {},
      imgDefault: require('@/assets/images/illustration/Pot1.svg'),
    }
  },
  async mounted() {
    const response = await getPengumuman();
      if (response.data) {
        if(response.data.status.code === '00'){
          this.pengumuman = response.data.data
        }
      }
  },
  methods: {
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
